const SYSTEM = 'system'

export default {
  SYSTEM
}
